module.exports = __webpack_public_path__ + "assets/294fda29999627c15683c77f1e9af2a4.jpg";